import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import MenuIcon from '@mui/icons-material/Menu';
import { colors } from '../mui-theme';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useSelector } from 'react-redux';

const NavigationItem = ({ isDesktop, links = [], contentLink = null }) => {
    let menuRef = useRef();
    let menuCurtain = useRef();

    const corpWebEnabled = useSelector((state) => state.toggleSettings.corpWebEnabled);
    const showAllLinks = corpWebEnabled && !isDesktop;

    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');
    };

    const handleMenuClick = () => {
        toggleMenu();
        menuCurtain.current.classList.toggle('show');
    };

    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;
    const showMenuClass = contentLink && contentLink.isSelected ? 'navbar__menu--show' : '';

    return (
        <Fragment>
            {!contentLink ? (
                <div className="navbar__icon--wrapper">
                    <a
                        className="navbar__link--block navbar__icon--menu"
                        onClick={handleMenuClick}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <MenuIcon style={{ color: colors.colorprimary80 }} />
                            <span
                                className="navbar__link--block"
                                style={{ marginLeft: '12px' }}
                            >
                                {translate('code.header.navigation.title')}
                            </span>
                        </div>
                    </a>
                </div>
            ) : (
                <Fragment>
                    {contentLink.url ? (
                        <a
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''} ${additionClass || ''}`}
                            href={contentLink.url || '#'}
                            dangerouslySetInnerHTML={{ __html: contentLink.name }}
                        ></a>
                    ) : (
                        <span
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''} ${additionClass || ''}`}
                            onClick={links.length > 0 ? toggleMenu : ''}
                        >
                            {contentLink.name}
                        </span>
                    )}
                    {links.length > 0 && (
                        <span
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        >
                            <ArrowBackIosIcon fontSize="inherit" />
                        </span>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <Fragment>
                    <div
                        className="navbar__courtain"
                        onClick={handleMenuClick}
                        ref={menuCurtain}
                    ></div>
                    <ul
                        className={`navbar__menu ${showMenuClass}`}
                        ref={menuRef}
                    >
                        <div className="navbar__menu-header">
                            {!contentLink ? (
                                <Fragment>
                                    <span className="navbar__title">
                                        {showAllLinks
                                            ? translate('code.site.nav.menu')
                                            : translate('code.product.nav.all.products')}
                                    </span>
                                    <span
                                        className="navbar__icon--close"
                                        onClick={handleMenuClick}
                                    >
                                        <CloseIcon />
                                    </span>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <span
                                        className="navbar__icon--caret-left navbar__icon"
                                        onClick={toggleMenu}
                                    >
                                        <ArrowBackIosIcon fontSize="inherit" />
                                    </span>
                                    <span
                                        className="navbar__title"
                                        onClick={toggleMenu}
                                        dangerouslySetInnerHTML={{
                                            __html: contentLink.name,
                                        }}
                                    ></span>
                                </Fragment>
                            )}
                        </div>
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className={`navbar__item ${link.isAllProductsLink ? 'navbar__item--all-products' : ''}`}
                                            key={index}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                            />
                                        </li>
                                    )
                            )}
                    </ul>
                </Fragment>
            )}
        </Fragment>
    );
};

export default NavigationItem;
